<template>
 <div id="app">
 <router-view v-if="isStandalonePage" />
 <el-container v-else class="app-container">
 <el-aside width="230px" class="app-aside">
 <div class="logo">
 <div class="logo-icon"><i class="el-icon-data-line"></i></div>
 <span class="logo-text">流量统计平台</span>
 </div>
 <el-menu
 :default-active="$route.path"
 router
 class="app-menu"
 background-color="transparent"
 text-color="rgba(255,255,255,0.65)"
 active-text-color="#fff"
 >
 <el-menu-item index="/">
 <i class="el-icon-s-home"></i>
 <span>全局统计</span>
 </el-menu-item>
 <el-menu-item index="/ip-stats">
 <i class="el-icon-connection"></i>
 <span>IP访问统计</span>
 </el-menu-item>
 <el-menu-item index="/ip-manage">
 <i class="el-icon-lock"></i>
 <span>IP管理</span>
 </el-menu-item>
 <el-menu-item index="/recent-visits">
 <i class="el-icon-time"></i>
 <span>最近访问记录</span>
 </el-menu-item>
 <el-menu-item index="/suspicious-ip">
 <i class="el-icon-warning"></i>
 <span>可疑IP预警</span>
 </el-menu-item>
 <el-menu-item index="/page-analytics">
 <i class="el-icon-document"></i>
 <span>页面分析</span>
 </el-menu-item>
 <el-menu-item index="/visitor-behavior">
 <i class="el-icon-user"></i>
 <span>访客行为</span>
 </el-menu-item>
 <el-menu-item index="/behavior-depth">
 <i class="el-icon-data-analysis"></i>
 <span>深度分析</span>
 </el-menu-item>
 <li class="el-menu-item custom-external-item" @click="openRealtimeScreen">
 <i class="el-icon-monitor"></i>
 <span>实时大屏</span>
 </li>
 <el-menu-item index="/websites">
 <i class="el-icon-menu"></i>
 <span>网站管理</span>
 </el-menu-item>
 <el-menu-item v-if="isSuper" index="/admin-users">
 <i class="el-icon-setting"></i>
 <span>账号管理</span>
 </el-menu-item>
 </el-menu>
 <div class="aside-footer">v1.0 · Powered by TRAE</div>
 </el-aside>
 <el-container>
 <el-header class="app-header">
 <span class="header-title">{{ $route.meta.title }}</span>
 <div class="header-right">
 <el-dropdown @command="handleCommand">
 <span class="user-dropdown-link">
 <span class="user-avatar"><i class="el-icon-user-solid"></i></span>
 {{ user.nickname || user.username || '用户' }}
 <el-tag v-if="isSuper" type="danger" size="mini" effect="dark" style="margin-left:4px">超管</el-tag>
 <i class="el-icon-arrow-down el-icon--right"></i>
 </span>
 <el-dropdown-menu slot="dropdown">
 <el-dropdown-item command="changePassword" icon="el-icon-key">修改密码</el-dropdown-item>
 <el-dropdown-item command="logout" divided icon="el-icon-switch-button">退出登录</el-dropdown-item>
 </el-dropdown-menu>
 </el-dropdown>
 </div>
 </el-header>
 <el-main class="app-main">
 <router-view />
 </el-main>
 </el-container>
 </el-container>
 <el-dialog title="修改密码" :visible.sync="pwdDialog" width="420px" append-to-body>
 <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="80px">
 <el-form-item label="原密码" prop="old_password">
 <el-input v-model="pwdForm.old_password" type="password" show-password />
 </el-form-item>
 <el-form-item label="新密码" prop="new_password">
 <el-input v-model="pwdForm.new_password" type="password" show-password />
 </el-form-item>
 <el-form-item label="确认密码" prop="confirm_password">
 <el-input v-model="pwdForm.confirm_password" type="password" show-password />
 </el-form-item>
 </el-form>
 <div slot="footer">
 <el-button @click="pwdDialog = false">取消</el-button>
 <el-button type="primary" @click="submitPassword" :loading="pwdSaving">确认</el-button>
 </div>
 </el-dialog>
 </div>
</template>

<script>
import { authApi } from './api';

export default {
 name: 'App',
 data() {
 const validateConfirm = (rule, value, callback) => {
 if (value !== this.pwdForm.new_password) {
 callback(new Error('两次输入的密码不一致'));
 } else {
 callback();
 }
 };
 return {
 user: {},
 pwdDialog: false,
 pwdSaving: false,
 pwdForm: { old_password: '', new_password: '', confirm_password: '' },
 pwdRules: {
 old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
 new_password: [
 { required: true, message: '请输入新密码', trigger: 'blur' },
 { min: 6, message: '密码至少6位', trigger: 'blur' }
 ],
 confirm_password: [
 { required: true, message: '请确认密码', trigger: 'blur' },
 { validator: validateConfirm, trigger: 'blur' }
 ]
 }
 };
 },
 computed: {
 isStandalonePage() {
 return this.$route.path === '/login' || this.$route.path === '/realtime-screen';
 },
 isSuper() {
 return Number(this.user.is_super) === 1;
 }
 },
 mounted() {
 this.loadUser();
 },
 watch: {
 $route() {
 this.loadUser();
 }
 },
 methods: {
 loadUser() {
 const stored = localStorage.getItem('wt_user');
 if (stored) {
 try { this.user = JSON.parse(stored); } catch (e) { this.user = {}; }
 }
 },
 openRealtimeScreen() {
 const { origin, pathname } = window.location;
 const base = pathname.replace(/\/[^/]*$/, '');
 window.open(origin + base + '/realtime-screen', '_blank');
 },
 handleCommand(cmd) {
 if (cmd === 'logout') this.handleLogout();
 else if (cmd === 'changePassword') {
 this.pwdForm = { old_password: '', new_password: '', confirm_password: '' };
 this.pwdDialog = true;
 }
 },
 async handleLogout() {
 try {
 await this.$confirm('确认退出登录？', '提示', { type: 'warning' });
 try { await authApi.logout(); } catch (e) {}
 localStorage.removeItem('wt_token');
 localStorage.removeItem('wt_user');
 this.$router.push('/login');
 } catch (e) {}
 },
 submitPassword() {
 this.$refs.pwdForm.validate(async valid => {
 if (!valid) return;
 this.pwdSaving = true;
 try {
 const res = await authApi.changePassword({
 old_password: this.pwdForm.old_password,
 new_password: this.pwdForm.new_password
 });
 if (res.code === 0) {
 this.$message.success('密码修改成功，请重新登录');
 localStorage.removeItem('wt_token');
 localStorage.removeItem('wt_user');
 this.pwdDialog = false;
 setTimeout(() => this.$router.push('/login'), 1500);
 } else {
 this.$message.error(res.msg);
 }
 } catch (e) {
 this.$message.error('修改失败');
 } finally {
 this.pwdSaving = false;
 }
 });
 }
 }
};
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }

html, body, #app {
 height: 100%;
 font-family: -apple-system, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

.app-container { height: 100%; }

.app-aside {
 background: #1e2a3a;
 color: #cdd6f4;
 overflow-x: hidden;
 display: flex;
 flex-direction: column;
}

.logo {
 height: 60px;
 display: flex;
 align-items: center;
 justify-content: center;
 gap: 10px;
 border-bottom: 1px solid rgba(255,255,255,0.06);
 flex-shrink: 0;
}

.logo-icon {
 width: 32px; height: 32px;
 border-radius: 7px;
 background: rgba(255,255,255,0.08);
 display: flex; align-items: center; justify-content: center;
 font-size: 18px; color: #94a3b8;
}

.logo-text {
 font-size: 16px;
 font-weight: 600;
 color: #f1f5f9;
 letter-spacing: 0.5px;
}

.app-menu {
 border-right: none !important;
 flex: 1;
 padding: 10px 0;
}

.app-menu .el-menu-item {
 margin: 3px 10px;
 border-radius: 7px;
 height: 44px;
 line-height: 44px;
 font-size: 13px;
 transition: all 0.2s;
}

.app-menu .el-menu-item:hover {
 background: rgba(255,255,255,0.05) !important;
 color: #fff !important;
}

.app-menu .el-menu-item.is-active {
 background: rgba(91,141,239,0.12) !important;
 color: #fff !important;
 position: relative;
}

.app-menu .el-menu-item.is-active::before {
 content: '';
 position: absolute;
 left: 0; top: 50%;
 transform: translateY(-50%);
 width: 3px; height: 55%;
 background: #5b8def;
 border-radius: 0 3px 3px 0;
}

.aside-footer {
 padding: 10px 0;
 text-align: center;
 font-size: 11px;
 color: rgba(255,255,255,0.2);
 border-top: 1px solid rgba(255,255,255,0.04);
 flex-shrink: 0;
}

.app-header {
 background: #fff;
 border-bottom: 1px solid #e8eaed;
 display: flex;
 align-items: center;
 justify-content: space-between;
 height: 56px;
 padding: 0 24px;
 z-index: 10;
}

.header-title {
 font-size: 17px;
 font-weight: 600;
 color: #1e293b;
}

.header-right { display: flex; align-items: center; }

.user-dropdown-link {
 display: flex;
 align-items: center;
 cursor: pointer;
 font-size: 13px;
 color: #475569;
 transition: color 0.2s;
}

.user-dropdown-link:hover { color: #5b8def; }

.user-avatar {
 width: 30px; height: 30px;
 border-radius: 50%;
 background: #475569;
 display: flex; align-items: center; justify-content: center;
 color: #fff; font-size: 15px;
 margin-right: 8px;
}

.app-main {
 background: #f5f6f8;
 padding: 22px;
 overflow-y: auto;
}

.custom-external-item {
 margin: 3px 10px;
 border-radius: 7px;
 height: 44px;
 line-height: 44px;
 font-size: 13px;
 cursor: pointer;
 color: rgba(255,255,255,0.65);
 transition: all 0.2s;
 padding: 0 20px;
 list-style: none;
}
.custom-external-item:hover {
 background: rgba(255,255,255,0.05) !important;
 color: #fff;
}
</style>